import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import Link from "next/link";
import { MDXRemote } from "next-mdx-remote";

import Head from "@/components/Head/Head";

import css from "./SinglePage.module.scss";

function ImageWrapper({ src, aspectRatio, ...props }) {
  const [aspectW, aspectH] = aspectRatio.split("/");
  return (
    <div className={css.imageContainer}>
      <a href={src} rel="noreferrer noopener" target="_blank">
        <Image
          src={src}
          width={500}
          height={(500 / aspectW) * aspectH}
          {...props}
          sizes="100vw"
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </a>
    </div>
  );
}
ImageWrapper.propTypes = {
  src: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
};
ImageWrapper.defaultProps = {
  aspectRatio: undefined,
};

function SinglePage({ post }) {
  const { date, title, thumbnail, desc, content } = post;
  return (
    <>
      <Head title={`${title} | SwarmBot`} desc={desc} />
      <article className={css.article}>
        <div className={css.infoContainer}>
          <time dateTime={date}>{date}</time>
          <h1>{title}</h1>
        </div>
        {thumbnail && (
          <div className={css.topImageContainer}>
            <Image
              src={thumbnail}
              width="300"
              height="120"
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto",
              }}
            />
          </div>
        )}
        <hr />
        <div className={css.content}>
          <MDXRemote {...content} components={{ Link, ImageWrapper }} />
        </div>
      </article>
    </>
  );
}
SinglePage.propTypes = {
  post: PropTypes.shape({
    title: PropTypes.string,
    date: PropTypes.string,
    content: PropTypes.shape({}),
    desc: PropTypes.string,
    thumbnail: PropTypes.string,
  }).isRequired,
};

export default SinglePage;
